import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { Spinner } from '@/components/ui/spinner';
import { useContentStudioApi } from '../../../../common/hooks/use-content-studio-api.hook';
import { ProductionPage } from '../../../../modules/vendor/studio/components/ProductionPage';

/**
 * A project opens as a Studio production — unless it is a canvas project made
 * before the Studio, which keeps opening on its canvas.
 */
const StudioProductionPage: React.FC = () => {
    const { projectUuid } = useParams<{ projectUuid: string }>();
    const api = useContentStudioApi();
    const [mode, setMode] = useState<'loading' | 'board' | 'canvas'>('loading');

    useEffect(() => {
        if (!projectUuid) return;
        let alive = true;
        api.getProject(projectUuid)
            .then((p: any) => alive && setMode(!p?.board?.version && (p?.canvasGraph || []).length > 0 ? 'canvas' : 'board'))
            .catch(() => alive && setMode('board'));
        return () => { alive = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectUuid]);

    if (!projectUuid) return <Navigate to="/marketing/content-studio" replace />;
    if (mode === 'loading') return <div className="fixed inset-0 z-40 flex items-center justify-center bg-background"><Spinner className="size-6" /></div>;
    if (mode === 'canvas') return <Navigate to={`/marketing/content-studio/${projectUuid}/canvas`} replace />;
    return <ProductionPage key={projectUuid} projectUuid={projectUuid} />;
};

export default StudioProductionPage;
